// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateUnifiedBrokerage(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "UnifiedPersonalProfileUpdated",
    "UnifiedProfileUpdateFailed"
  ]);
}

let variablesConverter = {"unifiedBrokerageInput":{},"__root":{"input":{"r":"unifiedBrokerageInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateUnifiedBrokerage_UnifiedPersonalProfileUpdated_agent":{"f":""},"updateUnifiedBrokerage":{"u":"response_updateUnifiedBrokerage"}}};

let wrapResponseConverterMap = {
  response_updateUnifiedBrokerage: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateUnifiedBrokerage_UnifiedPersonalProfileUpdated_agent":{"f":""},"updateUnifiedBrokerage":{"u":"response_updateUnifiedBrokerage"}}};

let responseConverterMap = {
  response_updateUnifiedBrokerage: unwrap_response_updateUnifiedBrokerage
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "UnifiedProfileUpdateFailed",
  "abstractKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedYourProfileProfessionalInformationFormBrokerageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUnifiedBrokerage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Agent",
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "UnifiedProfileSave_updatedAgent"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UnifiedPersonalProfileUpdated",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "UnifiedYourProfileProfessionalInformationFormBrokerageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUnifiedBrokerage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Agent",
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "biography",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "specialties",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "brokerage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "licenseNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfilePhoto",
                    "kind": "LinkedField",
                    "name": "profilePhoto",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": "photoUrl",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "ratio",
                            "variableName": "__relay_internal__pv__DevicePixelRatio"
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 96
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedProfileImage",
                    "kind": "LinkedField",
                    "name": "unifiedFeaturedPhoto",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 720
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": "url(width:720)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UnifiedPersonalProfileUpdated",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "da6a9713ac3dbdb226b76f6b78f9c705",
    "id": null,
    "metadata": {},
    "name": "UnifiedYourProfileProfessionalInformationFormBrokerageMutation",
    "operationKind": "mutation",
    "text": "mutation UnifiedYourProfileProfessionalInformationFormBrokerageMutation(\n  $input: UnifiedBrokerageInput!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  updateUnifiedBrokerage(input: $input) {\n    __typename\n    ... on UnifiedPersonalProfileUpdated {\n      agent {\n        ...UnifiedProfileSave_updatedAgent\n        nodeId\n      }\n    }\n    ... on UnifiedProfileUpdateFailed {\n      message\n    }\n  }\n}\n\nfragment SharingProfileMiniFormProfilePhoto_agent on Agent {\n  firstName\n  displayName\n  ...SharingProfileMiniFormProfilePhoto_currentPhoto_agent\n  ...SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent\n}\n\nfragment SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent on Agent {\n  id\n  profilePhoto {\n    __typename\n  }\n}\n\nfragment SharingProfileMiniFormProfilePhoto_currentPhoto_agent on Agent {\n  profilePhoto {\n    photoUrl: url(width: 96, ratio: $__relay_internal__pv__DevicePixelRatio)\n    id\n  }\n}\n\nfragment UnifiedProfileSave_updatedAgent on Agent {\n  nodeId\n  biography\n  specialties\n  brokerage\n  licenseNumber\n  profilePhoto {\n    id\n  }\n  ...SharingProfileMiniFormProfilePhoto_agent\n  unifiedFeaturedPhoto {\n    url(width: 720)\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

let wrap_response_updateUnifiedBrokerage = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateUnifiedBrokerage = unwrap_response_updateUnifiedBrokerage;
exports.wrap_response_updateUnifiedBrokerage = wrap_response_updateUnifiedBrokerage;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
